export const transactionPaymentActionTypes = {
  START_GET_PAYMENT_PAGE: "START_GET_PAYMENT_PAGE",
  GET_PAYMENT_PAGE_SUCCESS: "GET_PAYMENT_PAGE_SUCCESS",
  GET_PAYMENT_PAGE_FAILURE: "GET_PAYMENT_PAGE_FAILURE",

  START_CREATE_PAYMENT_TOKEN: "START_CREATE_PAYMENT_TOKEN",
  CREATE_PAYMENT_TOKEN_SUCCESS: "CREATE_PAYMENT_TOKEN_SUCCESS",
  CREATE_PAYMENT_TOKEN_FAILURE: "CREATE_PAYMENT_TOKEN_FAILURE",

  START_DELETE_PAYMENT_TOKEN: "START_DELETE_PAYMENT_TOKEN",
  DELETE_PAYMENT_TOKEN_SUCCESS: "DELETE_PAYMENT_TOKEN_SUCCESS",
  DELETE_PAYMENT_TOKEN_FAILURE: "DELETE_PAYMENT_TOKEN_FAILURE",
  
  START_GET_CREDIT_CARDS_DETAILS: "START_GET_CREDIT_CARDS_DETAILS",
  GET_CREDIT_CARDS_DETAILS_SUCCESS: "GET_CREDIT_CARDS_DETAILS_SUCCESS",
  GET_CREDIT_CARDS_DETAILS_FAILURE: "GET_CREDIT_CARDS_DETAILS_FAILURE",
};
